import { render, staticRenderFns } from "./mens.vue?vue&type=template&id=c93f2f40&scoped=true&lang=pug&"
import script from "./mens.vue?vue&type=script&lang=js&"
export * from "./mens.vue?vue&type=script&lang=js&"
import style0 from "./mens.vue?vue&type=style&index=0&id=c93f2f40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93f2f40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
